export default "/packs/images/pexels-shotpot-4047003~449c1e8d3648c4035ec2ffac700ccf23.jpg";